/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (boostSDAppConfig.searchSettings) {
  boostSDAppConfig.searchSettings.suggestionStyle = "style1";
  boostSDAppConfig.searchSettings.suggestionMobileStyle = "style2";
}

// function calc width of input and set result
const calcAndSetResultEqualInputSearch = () => {
  // get current Input of page
  const widthInput = document.querySelector(
    '#home-search .search-form__input-wrapper, header .banner-search form.search-form.search-bar__form[role="search"]'
  )?.offsetWidth;

  // get current result is showing
  const currentResult = document.querySelectorAll(
    "div.boost-sd__search-widget-init-wrapper:not(.boost-sd__g-hide)"
  );
  if (currentResult?.length !== 1) return;

  if (widthInput > 0) {
    currentResult[0]
      ?.querySelector(".boost-sd__instant-search-autocomplete")
      ?.setAttribute("style", `width: ${widthInput}px;`);
  }
};

// when window resize -> re-run
onresize = (event) => {
  calcAndSetResultEqualInputSearch();
};

/* Starts Boost 197291 */

const replacePlusSign = () => {
  if (window.location.href.includes("search?q=")) {
    let searchFormTitle = document.querySelector(
      ".boost-sd__search-form-title"
    );
    let strongNoResults = document.querySelector(
      ".boost-sd__no-search-result-page-search-result"
    );
    searchFormTitle.innerHTML = searchFormTitle.innerHTML.replaceAll("+", " ");
    strongNoResults.innerHTML = strongNoResults.innerHTML.replaceAll("+", " ");
  }
};

window.addEventListener("pageshow", replacePlusSign, false);

/* Ends Boost 197291 */
// customize for this store
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchContentResult", {
      name: "SearchContentResult - set width result equal input",
      apply() {
        return {
          afterRender(element) {
            calcAndSetResultEqualInputSearch();
          },
        };
      },
    });
    // --------------------
  },

  /* Open Slide Cart Upsell by AMP */
  (componentRegistry) => {
    componentRegistry.useModulePlugin("CartAPI", {
      name: "Custom onSucces add to cart",
      apply(builder) {
        builder.on("methodFulfilled", "addToCart", async (payload) => {
          /* Recall theme maker mini cart function here */
          window.SLIDECART_OPEN();
          window.SLIDECART_UPDATE();
          window.SLIDECART_OPENED();
          return payload;
        });
      },
    });
  },
]);
